


































































import Vue from 'vue'
import Drawer from '@/components/Global/Drawer.vue'
import { businessForm, rules } from './constants'
import { mutations, portalState } from '@/state'
import { apiCreateChildBusiness } from '@/api'

export default Vue.extend({
  name: 'CreateBusinessDrawer',
  props: {
    createBusinessDrawerOpened: Boolean,
    countries: Array,
    businesses: Array
  },
  components: { Drawer },
  computed: {
    loggedInUser () {
      return portalState.user
    },
  },
  data () {
    return {
      drawerActive: false,
      parent: null,
      business: { ...businessForm },
      rules
    }
  },
  methods: {
    close () {
      this.drawerActive = false
      this.$emit('closeDrawer')
    },
    createChildBusiness () {
      if (!this.$refs.form.validate()) return
      mutations.setSnackbar()
      apiCreateChildBusiness(this.parent, this.business).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => {
        this.close()
        this.$emit('resetTreeviewBusinesses')
        this.resetForm()
      })
    },
    resetForm () {
      this.business = { ...businessForm }
    }
  },
  watch: {
    createBusinessDrawerOpened (val) {
      this.drawerActive = val
    }
  },
  mounted () {
    this.parent = this.loggedInUser.businesses[0].id
  }
})
